import type { HTMLAttributes, ReactNode } from 'react';
import { StyledErrorMessage } from './ErrorMessage.styles';

interface ErrorMessageProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  testId?: string;
}

export function ErrorMessage({ children, testId, ...props }: ErrorMessageProps) {
  return (
    <StyledErrorMessage role="alert" data-testid={testId} {...props}>
      {children}
    </StyledErrorMessage>
  );
}
